(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-reviews"] && !Shopify.designMode) return;
  try {
    class CustomReviews extends HTMLElement {
    connectedCallback() {
      this.modal = this.querySelector('[data-cr-modal]');
      this.form = this.querySelector('.custom-reviews__modal-form');
      this.fields = this.querySelector('[data-cr-fields]');
      this.success = this.querySelector('[data-cr-success]');
      this.error = this.querySelector('[data-cr-error]');
      this.submitBtn = this.querySelector('[data-cr-submit]');

      this.querySelector('[data-cr-open-modal]')?.addEventListener('click', () => {
        this.#resetFormState();
        this.modal?.showModal();
      });

      this.querySelectorAll('[data-cr-close-modal]').forEach((btn) => {
        btn.addEventListener('click', () => this.modal?.close());
      });

      this.modal?.addEventListener('click', (event) => {
        if (event.target === this.modal) this.modal.close();
      });

      this.form?.addEventListener('submit', (event) => this.#onSubmit(event));

      this.querySelectorAll('.custom-reviews__page, .custom-reviews__page-arrow').forEach((el) => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
        });
      });
    }

    #resetFormState() {
      this.fields?.classList.remove('hidden');
      this.success?.classList.add('hidden');
      this.error?.classList.add('hidden');
      if (this.submitBtn) {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'Submit review';
      }
    }

    #showSuccess() {
      this.fields?.classList.add('hidden');
      this.success?.classList.remove('hidden');
      this.error?.classList.add('hidden');
      this.form?.reset();
    }

    /**
     * @param {SubmitEvent} event
     */
    async #onSubmit(event) {
      event.preventDefault();
      if (!(this.form instanceof HTMLFormElement)) return;

      this.error?.classList.add('hidden');
      if (this.submitBtn) {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Sending…';
      }

      const formData = new FormData(this.form);
      const rating = formData.get('contact[rating]') || '';
      const body = String(formData.get('contact[body]') || '');
      const product = formData.get('contact[product]') || '';
      const productUrl = formData.get('contact[product_url]') || '';

      formData.set(
        'contact[body]',
        [
          'New product review submission',
          `Product: ${product}`,
          `URL: ${productUrl}`,
          `Rating: ${rating}/5`,
          '',
          body,
        ].join('\n')
      );

      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'text/html',
          },
        });

        if (!response.ok && response.status >= 500) {
          throw new Error('Submit failed');
        }

        this.#showSuccess();
      } catch (_error) {
        this.error?.classList.remove('hidden');
        if (this.submitBtn) {
          this.submitBtn.disabled = false;
          this.submitBtn.textContent = 'Submit review';
        }
      }
    }
  }

  if (!customElements.get('custom-reviews')) {
    customElements.define('custom-reviews', CustomReviews);
  }
  } catch(e) { console.error(e); }
})();

})();
